
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.872 6.942a.871.871 0 00-.871.872v9.295a.871.871 0 00.871.87h16.266a.871.871 0 00.872-.87V7.814a.871.871 0 00-.872-.872.871.871 0 00-.87.872v8.423H1.743V7.814a.871.871 0 00-.872-.872z"}}),_c('path',{attrs:{"d":"M9.005-.029a.871.871 0 00-.871.871v9.513L6.137 8.358a.871.871 0 00-.61-.254.871.871 0 00-.624.254.871.871 0 000 1.235l3.485 3.485a.871.871 0 001.235 0l3.485-3.485a.871.871 0 000-1.235.871.871 0 00-1.234 0l-1.997 1.997V.842a.871.871 0 00-.872-.87z"}})])
          )
        }
      }
    